var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 77 97", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "title",
      null,
      "empty-files"
    ),
    React.createElement(
      "desc",
      null,
      "Created using Figma"
    ),
    React.createElement(
      "g",
      { transform: "translate(1005 -2050)" },
      React.createElement("use", { xlinkHref: "#a", transform: "translate(-1005 2058)", fill: "#F3F4F6" }),
      React.createElement(
        "mask",
        { id: "b" },
        React.createElement("use", { xlinkHref: "#a", fill: "#fff", transform: "translate(-1005 2058)" })
      ),
      React.createElement(
        "g",
        { mask: "url(#b)" },
        React.createElement("use", { xlinkHref: "#c", transform: "translate(-1005 2058)", fill: "#ACB0B7" })
      )
    ),
    React.createElement("use", { xlinkHref: "#d", transform: "translate(8)", fill: "#FFF" }),
    React.createElement("use", { xlinkHref: "#e", transform: "translate(32 42)", fill: "#ACB0B7" }),
    React.createElement("use", { xlinkHref: "#f", transform: "translate(56 1)", fill: "#F3F4F6" }),
    React.createElement(
      "g",
      { transform: "translate(1005 -2050)" },
      React.createElement(
        "mask",
        { id: "h" },
        React.createElement("use", { xlinkHref: "#g", fill: "#fff", transform: "translate(-950 2050)" })
      ),
      React.createElement(
        "g",
        { mask: "url(#h)" },
        React.createElement("use", { xlinkHref: "#i", transform: "translate(-950 2050)", fill: "#ACB0B7" })
      )
    ),
    React.createElement(
      "g",
      { transform: "translate(1005 -2050)" },
      React.createElement(
        "mask",
        { id: "j" },
        React.createElement("use", { xlinkHref: "#d", fill: "#fff", transform: "translate(-997 2050)" })
      ),
      React.createElement(
        "g",
        { mask: "url(#j)" },
        React.createElement("use", { xlinkHref: "#k", transform: "translate(-997 2050)", fill: "#ACB0B7" })
      )
    ),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { id: "a", fillRule: "evenodd", d: "M0 2.4A2.4 2.4 0 0 1 2.4 0h58.511a2.4 2.4 0 0 1 1.806.82L69 8v78.6a2.4 2.4 0 0 1-2.4 2.4H2.4A2.4 2.4 0 0 1 0 86.6V2.4z" }),
      React.createElement("path", { id: "c", d: "M69 8h1v-.376l-.247-.282L69 8zM62.717.82l-.752.658.752-.658zM2.4 1h58.511v-2H2.4v2zm59.565.478l6.282 7.18 1.506-1.316L63.47.162l-1.505 1.316zM68 8v78.6h2V8h-2zm-1.4 80H2.4v2h64.2v-2zM1 86.6V2.4h-2v84.2h2zM2.4 88A1.4 1.4 0 0 1 1 86.6h-2A3.4 3.4 0 0 0 2.4 90v-2zM68 86.6a1.4 1.4 0 0 1-1.4 1.4v2a3.4 3.4 0 0 0 3.4-3.4h-2zM60.911 1a1.4 1.4 0 0 1 1.054.478L63.47.161A3.4 3.4 0 0 0 60.91-1v2zM2.4-1A3.4 3.4 0 0 0-1 2.4h2A1.4 1.4 0 0 1 2.4 1v-2z" }),
      React.createElement("path", { id: "d", fillRule: "evenodd", d: "M0 2.4A2.4 2.4 0 0 1 2.4 0H48l21 20.5v66.1a2.4 2.4 0 0 1-2.4 2.4H2.4A2.4 2.4 0 0 1 0 86.6V2.4z" }),
      React.createElement("path", { id: "e", fillRule: "evenodd", d: "M12.568 11.768c3.362 3.358 6.721 6.718 10.08 10.078.398.397.455.699.189.976-.275.285-.59.229-.999-.18-3.352-3.352-6.705-6.704-10.056-10.058-.087-.088-.158-.193-.303-.37-.117.167-.176.284-.264.371-3.35 3.355-6.703 6.707-10.055 10.06-.407.407-.725.462-.999.175-.264-.277-.205-.578.192-.976l10.08-10.078c.08-.081.177-.146.282-.232-.126-.132-.209-.224-.296-.31C7.067 7.87 3.714 4.517.362 1.165.288 1.09.208 1.02.142.939-.058.693-.042.38.175.167.392-.045.702-.055.948.148c.08.068.15.147.225.221 3.345 3.345 6.69 6.69 10.034 10.037.088.088.157.196.371.346.065-.11.11-.238.197-.325C15.13 7.066 18.49 3.705 21.85.347c.393-.393.701-.45.975-.178.276.273.223.586-.167.977C19.307 4.497 15.955 7.85 12.602 11.2c-.09.09-.188.17-.364.325.144.104.25.161.33.242z" }),
      React.createElement("path", { id: "f", fillRule: "evenodd", d: "M0 0l20 20H0V0z" }),
      React.createElement("path", { id: "g", fillRule: "evenodd", d: "M0 0v22h22" }),
      React.createElement("path", { id: "i", d: "M0 22h-1v1h1v-1zM-1 0v22h2V0h-2zm1 23h22v-2H0v2z" }),
      React.createElement("path", { id: "k", d: "M48 0l.699-.716L48.407-1H48v1zm21 20.5h1v-.421l-.302-.295L69 20.5zM2.4 1H48v-2H2.4v2zM47.301.716l21 20.5 1.397-1.432-21-20.5L47.302.716zM68 20.5v66.1h2V20.5h-2zM66.6 88H2.4v2h64.2v-2zM1 86.6V2.4h-2v84.2h2zM2.4 88A1.4 1.4 0 0 1 1 86.6h-2A3.4 3.4 0 0 0 2.4 90v-2zM68 86.6a1.4 1.4 0 0 1-1.4 1.4v2a3.4 3.4 0 0 0 3.4-3.4h-2zM2.4-1A3.4 3.4 0 0 0-1 2.4h2A1.4 1.4 0 0 1 2.4 1v-2z" })
    )
  );
});